import ListCreditScoreOverTimeBox from './ListCreditScoreOverTimeBox'

export default ListCreditScoreOverTimeBox
